import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MenuEntry } from '../../../models/misc/menu-entry';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store';
import { getUsername } from '../../../store/selectors/user.selector';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslationEnum } from '../../../../assets/i18n/translation-enum';
import { getPermissionsSelector } from '../../../store/selectors/user.selector';
import { Permission } from '../../../models/user/permission';

@Component({
  selector: 'tg-mobile-menu',
  templateUrl: './mobile-menu.component.html',
  styleUrls: ['./mobile-menu.component.scss'],
})
export class MobileMenuComponent implements OnInit, OnDestroy {
  username$: Observable<string>;
  menuOpen = false;
  profileExpand = false;
  hasGymPermission = false;

  TranslationEnum = TranslationEnum;

  private destroy = new Subject<void>();

  @Input()
  entries: MenuEntry[];

  @Input()
  isGym: boolean;

  constructor(public router: Router, private store: Store<AppState>) {}

  ngOnInit(): void {
    this.username$ = this.store.select(getUsername);
    this.store
      .select(getPermissionsSelector)
      .pipe(takeUntil(this.destroy))
      .subscribe((permissions) => {
        this.hasGymPermission = permissions?.includes(Permission.MANAGE_GYM);
      });
  }

  showMenu(): void {
    this.menuOpen = !this.menuOpen;
  }

  logout(): void {}

  expandProfile(): void {
    this.profileExpand = !this.profileExpand;
  }

  closeMenu(): void {
    this.menuOpen = false;
  }

  getMenuIcon(route: string, icon: string): string {
    const isActive = this.router.url.includes(route);
    return `/assets/images/menu/${icon}${isActive ? '-active' : ''}.svg`;
  }

  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.complete();
  }
}
